import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SunSafety = lazyWithPreload(() => import('./SunSafety'))
